import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import cn from "../../utilities/tailwind-merge";

/**
 * Single-line text that ends in "…" when it doesn't fit, and shows the full value in a tooltip —
 * but only when it was actually cut off, so short values don't get pointless tooltips.
 */
function TruncatedText({ children, tooltip, className, placement = "topLeft" }) {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const measure = () => {
        const el = ref.current;
        if (el) setIsTruncated(el.scrollWidth > el.clientWidth + 1);
    };

    return (
        <Tooltip title={isTruncated ? (tooltip ?? children) : null} placement={placement} mouseEnterDelay={0.3}>
            <span ref={ref} onMouseEnter={measure} onFocus={measure} className={cn("block min-w-0 truncate", className)}>
                {children}
            </span>
        </Tooltip>
    );
}

TruncatedText.propTypes = {
    children: PropTypes.node,
    tooltip: PropTypes.node,
    className: PropTypes.string,
    placement: PropTypes.string,
};

export default TruncatedText;
